import React, { useEffect } from 'react'

import DayPicker from 'modules/core/components/DayPicker'
import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface DateElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

/**
 * Editor component for DateElement
 */
const DateElementQuestion: React.FC<DateElementQuestionProps> = ({
  element,
  onChange,
  disabled,
}) => {
  const [value, setValue] = React.useState<string | undefined>(element.answer?.answer)

  useEffect(() => {
    setValue(element.answer?.answer)
  }, [element.id, element.answer?.answer])

  const handleOnChange = (newValue: string) => {
    setValue(newValue)
    onChange?.({ answer: newValue })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && !value) {
        return i18n.t('forms.render.answer_required')
      }
    }
    return undefined
  }

  return (
    // TODO: use F0Datepicker
    <DayPicker
      mode="single"
      label=""
      aria-label={element.label}
      value={value}
      onChange={handleOnChange}
      error={getError()}
      mandatory={element.mandatory}
      readonly={disabled}
    />
  )
}

export default DateElementQuestion
